module.exports = __webpack_public_path__ + "img/54.fbd9d8c9.png";